<template>
    <!-- 自定义title -->
    <div>
      <span class="title-text">多选得分设置</span>
      <el-tooltip placement="right" effect="light">
        <div slot="content">
          1、全选对才得分，少选错选不得分：只有学生填凃的结果与标准答案完全一致才得分<br />
          2、选对但不全，得（）分：<br />
          ● 全选对，得满分 ● 错选，不得分 ● 选对但不全，得设置的得分<br />
          3、按选项得分，一个选项（）分：<br />
          ● 全选对，得满分 ● 错选，不得分 ● 选对但不全，每选对一个得设置的得分<br />
          4、多种答案组合：可以设置不同选项组合对应的得分<br />
          5、断句题型：<br />
          ● 全选对，得满分 ● 超过规定的填凃数量，不得分 ● 选对1个，得设置的得分
        </div>
        <span class="el-icon-question"></span>
      </el-tooltip>
    </div>
</template>

<script>
export default {
  name: 'MultipleScoreTitle',
  data() {
    return {
      title: '多选得分标题',
    };
  },
}
</script>

<style scoped lang="scss">
.title-text {
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.title-text ::v-deep img {
  vertical-align: text-bottom;
}
</style>
